import { Field, FieldProps, useControlId } from './Field'

export function TextField({
  label,
  error,
  hint,
  labelStyle,
  className,
  style,
  id,
  value,
  onChange,
  type = 'text',
  controlClassName = '',
  controlStyle,
  ...rest
}: FieldProps & {
  value: string
  onChange: (value: string) => void
  controlClassName?: string
  controlStyle?: React.CSSProperties
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'id' | 'className' | 'style'>) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <input
        id={controlId}
        type={type}
        className={`form-control ${controlClassName}`.trim()}
        style={controlStyle}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        {...rest}
      />
    </Field>
  )
}
